// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-F":"F_NA_outdoor-recreation-F__PEuyh"};